import axios from '@/plugins/axiosInstance'
import { googleIntegration } from '@/networking/urlManager'
import { responseHandlerService } from '@/plugins/responseHandlerService'
import { integrations } from '../../../composables/use-integration-management/state'

/**
 * Revokes access for a Google account
 * @param {string} accountId - The Google account ID to revoke
 * @param {string} assetId - The asset ID
 * @param {Function} t - Translation function passed from parent
 * @returns {Promise<boolean>} Success status
 */
export const revokeAccount = async (accountId, assetId, t) => {
  try {
    await axios.post(googleIntegration.revokeAccount, {
      accountId,
      assetId,
      revokeProperty: true // Mülk bağlantısını da kaldır
    })

    // Update Google integration status
    const googleIntegrationItem = integrations.value.find(i => i.id === 6)
    if (googleIntegrationItem) {
      googleIntegrationItem.connected = false
    }

    responseHandlerService.handleSuccess(
        t('Başarılı bir şekilde hesap bağlantısı kesildi.'),
    )

    return true
  } catch (error) {
    responseHandlerService.handleError(
        error,
        t('Hesap bağlantısı kesilirken bir hata oluştu.'),
    )
    return false
  }
}
